// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import axios from 'axios'

Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.$baseUrl = process.env.baseUrl
Vue.prototype.$formUrl = process.env.formUrl
Vue.prototype.$axios = axios

// 修改标题
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

let requestPromise = function (token) {
  return new Promise((resolve, reject) => {
    axios.get(Vue.prototype.$baseUrl + '/api/UpTop/RefreshToken', {
      params: {
        UserID: token.userID,
        refresh_token: token.refresh_Token
      }
    }).then((res) => {
      resolve(res)
    }).catch((res) => {
      reject(res)
    })
  })
}

// request 拦截器
axios.interceptors.request.use(
  config => {
    if (config.url.indexOf('api/UpTop/Login') !== -1 || config.url.indexOf('api/UpTop/RefreshToken') !== -1) {
      return config
    }
    const tokenStr = sessionStorage.getItem('accessToken')
    if (tokenStr) {
      var token = JSON.parse(tokenStr)
      // 是否超出有效时间
      if (new Date().getTime() - token.createTime > (token.expies_in * 1000)) {
        return requestPromise(token).then((res) => {
          var obj = res.data
          sessionStorage.setItem('accessToken', JSON.stringify({
            access_token: obj.access_token,
            expies_in: obj.expies_in,
            refresh_Token: obj.refresh_Token,
            createTime: new Date().getTime(),
            userID: obj.userID,
            oasToken: obj.oasToken
          }))
          config.headers.Authorization = obj.access_token
          return config
        }).catch((res) => {
          return Promise.reject(res)
        })
      } else {
        // 头部添加token
        config.headers.Authorization = token.access_token
      }
    }
    return config
  },
  err => {
    return Promise.reject(err)
  })

// response 拦截器
axios.interceptors.response.use(
  response => {
    // 没有权限跳转到登录页
    if (response.data.code && response.data.code === 401) {
      router.replace({
        path: 'Login',
        query: {
          redirect: router.currentRoute.fullPath
        }
      })
    }
    return response
  },
  err => {
    if (err.response && err.response.status === 401) {
      const token = sessionStorage.getItem('accessToken')
      if (token) {
        axios.post(Vue.prototype.$baseUrl + '/')
      }
      router.replace({
        path: 'Login',
        query: {
          redirect: router.currentRoute.fullPath
        }
      })
    }
    return Promise.reject(err) // 返回接口返回的错误信息
  }
)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js